export default "__VITE_ASSET__BWVLDlOE__"